export const TELOS_ANALYTICS_EVENT_NAMES = {
    loginStarted: 'Login Started',
    loginSuccessful: 'Login Successful',
    loginSuccessfulMetamask: 'Login Successful - Metamask',
    loginFailedMetamask: 'Login Failed - Metamask',
    loginSuccessfulSafepal: 'Login Successful - Safepal',
    loginFailedSafepal: 'Login Failed - Safepal',
    loginSuccessfulOreId: 'Login Successful - OreId',
    loginFailedOreId: 'Login Failed - OreId',
    loginFailedWalletConnect: 'Login Failed - WalletConnect',
    loginSuccessfulWalletConnect: 'Login Successful - WalletConnect',
    loginSuccessfulBrave: 'Login Successful - Brave',
    loginFailedBrave: 'Login Failed - Brave',
};
